// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sc9c","type":"styles_type__1xDLF","choices":"styles_choices__2r-fJ"};